import { createApp } from 'vue';
import { AccountLink } from '@rei/account-flyout';
import { getUser } from '@rei/session';
import getAdobeTargetJsonOffer from '@rei/adobe-target-functions';
import AccountLinkFragment from './components/AccountLinkFragment.vue';
import LoadingFragment from './components/LoadingFragment.vue';
import AccountNavComponent from './components/AccountNavComponent.vue';
import AccountFlyoutComponent from './components/AccountFlyoutComponent.vue';
import SignInNudgeComponent from './components/SignInNudgeComponent.vue';

const gNav = document.querySelector('.gnav');
const isWhiteNav = gNav !== null;
const { clientWidth } = window.document.body;

let isAccountMounted = false;
let isSignInNudgeMounted = false;

let user = null;
let createButtonExperience = 'control';
let signInNotificationExperience = 'control';

if (isWhiteNav) {
  /* This is a default loading fragment that will display first and
    visually communicate to the user that something related to their
    account login is still pending.
  */
  // TODO: consider loading icon for mobile if test wins?
  createApp(LoadingFragment).mount('[data-ui="login-module-greeting"]');

  user = getUser()
    .then(async (userObj) => {
      user = userObj;
      const accountListItem = document.querySelector(
        '[data-ui="login-module-greeting-account-link"]',
      );
      if (accountListItem.hasAttribute('data-visible')) {
        accountListItem.removeAttribute('data-visible');
      }
      if (user && user.isLoggedIn) {
        createApp(AccountNavComponent, { user }).mount(
          '[data-ui="login-module-greeting-account-link"]',
        );
        const sentMemberViewMetric = sessionStorage.getItem('memberViewSent');
        if (
          window &&
          window.metrics &&
          user.membership &&
          !sentMemberViewMetric &&
          clientWidth < 992
        ) {
          window.metrics.click({
            siteId: 'global-sign-in',
            checkoutRewardsTotal: user.membership.dividendBalance || 0,
          });
          sessionStorage.setItem('memberViewSent', 'true');
        }
      } else {
        try {
          const accountCreateAsButtonTest = await getAdobeTargetJsonOffer(
            'account-create-as-button',
          );
          if (accountCreateAsButtonTest && accountCreateAsButtonTest.length) {
            const [{ content }] = accountCreateAsButtonTest;
            const [[{ experience }]] = content;
            createButtonExperience = experience;
          }
        } catch (e) {
          console.error('Error with getAdobeTargetJsonOffer', e);
        }
        try {
          const signInNotificationTest = await getAdobeTargetJsonOffer(
            'navigation-alert-sign-in-mobile',
          );
          if (signInNotificationTest && signInNotificationTest.length) {
            const [{ content }] = signInNotificationTest;
            const [[{ experience }]] = content;
            signInNotificationExperience = experience;
          }
        } catch (e) {
          console.error('Error with getAdobeTargetJsonOffer', e);
        }
        createApp(AccountLinkFragment, { createButtonExperience, signInNotificationExperience }).mount(
          '[data-ui="login-module-greeting-account-link"]',
        );
      }

      const accountToggleButton = document.querySelector(
        "[data-ui='site-header-action-local-account']",
      );
      const navbarWrapper = document.querySelector("[data-ui='site-navigation']");

      // Mount account and set event listeners, this function will only be executed if the account
      // button is hover or focused. Otherwise there is no need to mount component
      const mountAccount = () => {
        isAccountMounted = true;
        // Insert <li> element next to account toggle button to render Account component
        accountToggleButton.parentNode.insertAdjacentHTML(
          'afterEnd',
          `<li class="account-dropdown ${
            isWhiteNav && 'account-dropdown--white-nav'
          }"><div id="account-placement"></div></li>`,
        );
        createApp(AccountFlyoutComponent, { user }).mount('#account-placement');
      };

      const signInLink = document.querySelector("[data-ui='login-module-greeting']");
      const mountSignInNudge = () => {
        isSignInNudgeMounted = true;

        signInLink.insertAdjacentHTML(
          'afterEnd',
          `<li class="sign-in-nudge-dropdown ${
            isWhiteNav && 'sign-in-nudge--white-nav'
          }"><div id="sign-in-nudge-placement"></div></li>`,
        );

        createApp(SignInNudgeComponent, { user, createButtonExperience }).mount(
          '#sign-in-nudge-placement',
        );
      };

      if (accountToggleButton && navbarWrapper && isWhiteNav) {
        ['focus', 'mouseenter'].forEach((eventName) =>
          accountToggleButton.addEventListener(
            eventName,
            () => {
              if (!isAccountMounted) {
                mountAccount();
              }
            },
            {
              once: true,
            },
          ),
        );

        window.addEventListener('load', () => {
          if (!isAccountMounted) {
            mountAccount();
          }
        });
      }

      if (signInLink && navbarWrapper && isWhiteNav) {
        setTimeout(() => {
          if (!isSignInNudgeMounted) {
            mountSignInNudge();
          }
        }, 2000);
      }
    })
    .catch(() => {
      createApp(AccountLink).mount('[data-ui="login-module-greeting"]');
    });
}
